// src/services/meetingRoomApi.js
import axios from "axios";
import { apiURL } from "../config/config"; // <- ใช้ของเดิมคุณ

const ROOMS_CACHE_KEY = "meeting-rooms:rooms:v1";
const ROOMS_CACHE_TTL_MS = 30 * 60 * 1000;

const authHeaders = () => {
  const token = localStorage.getItem("token");
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };
};

export const fetchRooms = async () => {
  const res = await axios.get(`${apiURL}meeting-rooms/rooms`, authHeaders());
  return res.data;
};

export const fetchTodayAvailability = async () => {
  const res = await axios.get(
    `${apiURL}meeting-rooms/availability/today`,
    authHeaders()
  );
  return res.data;
};

export const getCachedRooms = () => {
  try {
    const raw = sessionStorage.getItem(ROOMS_CACHE_KEY);
    if (!raw) return null;

    const cached = JSON.parse(raw);
    if (
      !Array.isArray(cached?.rooms) ||
      Date.now() - cached.cachedAt > ROOMS_CACHE_TTL_MS
    ) {
      sessionStorage.removeItem(ROOMS_CACHE_KEY);
      return null;
    }

    return cached.rooms;
  } catch (error) {
    console.warn("Unable to read cached meeting rooms", error);
    return null;
  }
};

export const cacheRooms = (rooms) => {
  try {
    sessionStorage.setItem(
      ROOMS_CACHE_KEY,
      JSON.stringify({ rooms, cachedAt: Date.now() })
    );
  } catch (error) {
    console.warn("Unable to cache meeting rooms", error);
  }
};

export const fetchBookings = async ({ roomId, dateKey }) => {
  const res = await axios.get(
    `${apiURL}meeting-rooms/bookings`,
    {
      ...authHeaders(),
      params: { roomId, dateKey },
    }
  );
  return res.data;
};

export const fetchBookingsByDateRange = async ({
  roomId,
  startDate,
  endDate,
}) => {
  const res = await axios.get(
    `${apiURL}meeting-rooms/bookings`,
    {
      ...authHeaders(),
      params: { roomId, startDate, endDate },
    }
  );
  return res.data;
};

export const createBooking = async (payload) => {
  const res = await axios.post(
    `${apiURL}meeting-rooms/bookings`,
    payload,
    authHeaders()
  );
  return res.data;
};

// ✅ FIX: ไม่รับ token จาก param แล้ว ใช้ authHeaders() เหมือนกันหมด
export const fetchMyBookings = async ({ roomId, dateKey }) => {
  const res = await axios.get(`${apiURL}meeting-rooms/bookings/mine`, {
    ...authHeaders(),
    params: { roomId, dateKey },
  });
  return res.data;
};

// ✅ PATCH: แก้ไข booking (เฉพาะเจ้าของ/แอดมินตาม backend)
export const updateBooking = async (id, payload) => {
  const res = await axios.patch(
    `${apiURL}meeting-rooms/bookings/${id}`,
    payload,
    authHeaders()
  );
  return res.data;
};

// ✅ DELETE: ลบ booking (เฉพาะเจ้าของ/แอดมินตาม backend)
export const deleteBooking = async (id) => {
  const res = await axios.delete(
    `${apiURL}meeting-rooms/bookings/${id}`,
    authHeaders()
  );
  return res.data;
};

